import { useState } from 'react';
import { uploadFile } from '../services/cloudinary';

export const useFileUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);

  const upload = async (file, folder = 'zedscholar') => {
    setUploading(true);
    setError(null);
    setProgress(0);

    try {
      // Simulate progress (Cloudinary doesn't provide progress in client-side uploads)
      const progressInterval = setInterval(() => {
        setProgress(prev => Math.min(prev + 10, 90));
      }, 100);

      const result = await uploadFile(file, folder);
      
      clearInterval(progressInterval);
      setProgress(100);
      
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setUploading(false);
      setTimeout(() => setProgress(0), 1000);
    }
  };

  return {
    upload,
    uploading,
    error,
    progress
  };
};
